import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import ListMission from './ListMission';
import PickingService from '../../../../services/PickingService';
import BackButton from '../../../../components/UI/BackButton';
import { ENUMS } from '../../../../utils/constants';
import { translate } from '../../../../utils/util';

const Missions = (props) => {
    const checkOrder = () => {
        if (!orderItemsConfirmed()) {
            props.unblockOrder(props.order.orderId);
        }
    }

    const orderItemsConfirmed = () => {
        if (!props.order.orderId) {
            return;
        }

        const itemsWaitingAndInProgress = props.order.items.filter((i) => {
            return i.status === ENUMS.eOrderItemStatus.Waiting.value || i.status === ENUMS.eOrderItemStatus.InProgress.value;
        }).length;
        return ((props.order.items.length - itemsWaitingAndInProgress) > 0);
    };

    return (
        <div>
            <BackButton {...props} callback={checkOrder} />
            <div className="container-fluid h-65">
                <div className="row">
                    <div className="title">
                        <i className="mdi mdi-dolly" />
                        {translate('expedition:picking.title')}
                    </div>
                    <div className="subtitle">
                        | <i className="material-icons">business_center</i>
                        {translate('expedition:picking.order')} {props.match.params.id}
                    </div>
                    <div className="subtitle">
                        | <i className="material-icons">playlist_add_check</i>
                        {translate('expedition:picking.missions')}
                    </div>
                </div>
            </div>
            <div className="container-fluid" style={{ marginTop: '40px' }}>
                <ListMission data={props.order.items} />
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        order: state.pickingReducer.order
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getMissions: (orderId) => {
            dispatch(PickingService.getMissions(orderId));
        },
        unblockOrder: (orderId, callback) => {
            dispatch(PickingService.unblockOrder(orderId, callback));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Missions)));
